import { WixDesignSystemProvider } from "@wix/design-system";
import React from "react";
const UiComponentsProvider = ({ children }) => {
  return /* @__PURE__ */ React.createElement(WixDesignSystemProvider, { features: { newColorsBranding: true } }, children);
};
export {
  UiComponentsProvider
};
//# sourceMappingURL=ui-components-provider.js.map
